import React, { useState, useEffect } from 'react';

const Loading = () => {
    const [dots, setDots] = useState(3);

    useEffect(() => {
        const dotsInterval = setInterval(() => {
            setDots(prev => (prev >= 3 ? 0 : prev + 1));
        }, 500);

        return () => {
            clearInterval(dotsInterval);
        }
    }, []);

    return (<div className='loading'>
        <div className='content'>
            <p>Carregando{".".repeat(dots)}</p>
        </div>
        <div className="background"></div>
    </div>);
}

export default Loading;